import { Money, MoneyInput } from '@rematter/frontend-lib-api-client';

export const toMoney = (money: MoneyInput): Money => ({
  amount: money.amount,
  currencyCode: money.currencyCode,
  __typename: 'Money' as const,
});
